// intro-app/account/changePassword.js

(function () {
    'use strict';
    var controllerId = 'changePassword';
    angular.module('intro-app').controller(controllerId, ['datacontext', '$translate', changePasswordFn]);

    function changePasswordFn(datacontext, $translate) {
        var vm = this;
        vm.error = null;
        vm.sucess = false;
        vm.account = getAccount();
        vm.changePassword = changePassword;

        vm.lingua = $translate.use();

        function getAccount() {
            return datacontext.account_get().then(function (data) {
                vm.item = {
                    "Username": data.Username,
                    "OldPassword": "",
                    "NewPassword": "",
                    "NewPassword2": ""
                };
                return vm.account = data;
            });
        }

        function changePassword() {
            vm.error = null;
            vm.success = false;
            return datacontext.account_changePassword(vm.item).then(function (response) {
                if (response.status == 200) {
                    vm.success = true;
                    vm.item.OldPassword = "";
                    vm.item.NewPassword = "";
                    vm.item.NewPassword2 = "";
                }
                else {
                    vm.error = response.data;
                }
            });
        }        
    }
})();